<app-spinner *ngIf="isLoading" placement="full-page"></app-spinner>

<div class="admin-hq-page" *ngIf="!isLoading">
  <header class="hq-header">
    <div>
      <p class="eyebrow">TailOne HQ</p>
      <h1>App Dashboard</h1>
      <p class="subline">Current app activity and onboarding state.</p>
    </div>
    <div class="header-actions">
      <span class="updated">Updated {{ loadedAtLabel }}</span>
      <button type="button" class="refresh-button" (click)="loadDashboard()">Refresh</button>
    </div>
  </header>

  <p class="error" *ngIf="error">{{ error }}</p>

  <section class="metrics-grid">
    <div class="metric-tile">
      <span class="metric-label">New Users 24h</span>
      <strong>{{ newUsers24h }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">New Users 7d</span>
      <strong>{{ newUsers7d }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">Total Users</span>
      <strong>{{ totalUsers }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">Users With Membership</span>
      <strong>{{ usersWithMembership }}</strong>
    </div>
    <a class="metric-tile metric-link" routerLink="/admin/review-memberships">
      <span class="metric-label">Memberships To Review</span>
      <strong>{{ pendingMembershipReviewCount }}</strong>
      <span class="link-text">Open review panel</span>
    </a>
    <div class="metric-tile">
      <span class="metric-label">Without Accepted Membership</span>
      <strong>{{ usersWithoutAcceptedMembership }}</strong>
    </div>
  </section>

  <section class="summary-grid">
    <div class="panel">
      <div class="panel-header">
        <h2>Membership Types</h2>
        <span>{{ membershipTypeRows.length }} types</span>
      </div>
      <div class="empty" *ngIf="membershipTypeRows.length === 0">No memberships yet.</div>
      <div class="bar-row" *ngFor="let row of membershipTypeRows">
        <div class="bar-label">
          <span>{{ row.label }}</span>
          <strong>{{ row.count }}</strong>
        </div>
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="totalUsers ? (row.count / totalUsers) * 100 : 0"></div>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-header">
        <h2>Onboarding Stages</h2>
        <span>Users without accepted membership</span>
      </div>
      <div class="empty" *ngIf="onboardingStageRows.length === 0">No blocked onboarding stages.</div>
      <div class="bar-row" *ngFor="let row of onboardingStageRows">
        <div class="bar-label">
          <span>{{ row.label }}</span>
          <strong>{{ row.count }}</strong>
        </div>
        <div class="bar-track">
          <div class="bar-fill orange" [style.width.%]="usersWithoutAcceptedMembership ? (row.count / usersWithoutAcceptedMembership) * 100 : 0"></div>
        </div>
      </div>
    </div>
  </section>

  <section class="watcher-section">
    <div class="table-panel">
      <div class="panel-header">
        <h2>Latest Flight Watchers</h2>
        <span>{{ latestWatchers.length }} latest</span>
      </div>
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Created</th>
              <th>Plan</th>
              <th>User</th>
              <th>Seats</th>
              <th>Checked</th>
              <th>Expires</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let watcher of latestWatchers">
              <td>{{ watcher.createdAtLabel }}</td>
              <td>{{ watcher.displayName }}</td>
              <td>{{ watcher.userId }}</td>
              <td>{{ watcher.seatsLabel }}</td>
              <td>{{ watcher.checkedAtLabel }}</td>
              <td>{{ watcher.expiresOnLabel }}</td>
              <td><a [routerLink]="watcher.route">View</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-panel">
      <div class="panel-header">
        <h2>Latest Always-On Watchers</h2>
        <span>{{ latestPersistentWatchers.length }} latest</span>
      </div>
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Created</th>
              <th>Plan</th>
              <th>User</th>
              <th>Status</th>
              <th>Seats</th>
              <th>Checked</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let watcher of latestPersistentWatchers">
              <td>{{ watcher.createdAtLabel }}</td>
              <td>{{ watcher.displayName }}</td>
              <td>{{ watcher.userId }}</td>
              <td>{{ watcher.status }}</td>
              <td>{{ watcher.seatsLabel }}</td>
              <td>{{ watcher.checkedAtLabel }}</td>
              <td><a [routerLink]="watcher.route">View</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
